<template>
    <pre-datetimepicker
        v-bind="$attrs"
        :input-class-name="className"
        :locale="$i18n.locale"
        :twelve-hour-time="twelveHourTime"
        v-on="$listeners"
    />
</template>

<script>
    import { PreDatetimepicker } from 'pre-ui';

    export default {
        components: { PreDatetimepicker },

        props: {
            className: {
                type: String,
                default: 'form-input',
            },
        },

        computed: {
            twelveHourTime() {
                return this.$i18n.locale === 'en';
            },
        },
    };
</script>
